import {
  StyleSheet,
  TextInput,
  View,
  Text,
  StyleProp,
  ViewStyle,
  TouchableOpacity,
} from "react-native";
import { colors } from "../common/styles/colors";
import { fonts } from "../common/styles/fonts";
import { AlertCircleIcon } from "../common/icons/AlertCircle";
import { IconLeftShortArrow } from "../common/icons/IconLeftShortArrow";
import { FC, ReactNode } from "react";

export function Header({
  containerStyle,
  rightButton,
  leftButton,
  onPressLeft,
  onPressRight,
}: {
  containerStyle?: StyleProp<ViewStyle>;
  rightButton?: ReactNode;
  leftButton?: ReactNode;
  onPressLeft?: () => void;
  onPressRight?: () => void;
}) {
  return (
    <View style={[styles.container, containerStyle]}>
      <TouchableOpacity onPress={onPressLeft}>
        {!!leftButton ? leftButton : <IconLeftShortArrow />}
      </TouchableOpacity>
      {!!rightButton && (
        <TouchableOpacity onPress={onPressRight}>
          {rightButton}
        </TouchableOpacity>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    paddingHorizontal: 16,
    paddingVertical: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  input: {
    height: 46,
    backgroundColor: colors.LightGrayishYellow,
    borderRadius: 10,
    borderWidth: 0.5,
    borderColor: colors.gray81,
    textAlign: "center",
    outlineStyle: "none",
  },
  errorContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
});
